import { useCallback } from 'react';
import {
  useEditAssumptionsForm,
  useCareEnvironmentSelections,
  useCareEnvironmentCosts,
  useAutoSaveAssumptions,
} from '../hooks';
import {
  ProjectedCostBanner,
  CareAssumptionsSection,
  CareTimelineTable,
  InflationRateSection,
} from '.';

export function EditAssumptionsContent() {
  const form = useEditAssumptionsForm();
  const envSelections = useCareEnvironmentSelections(form.updatePreviewClient, form.previewClient);
  const envCosts = useCareEnvironmentCosts(form.updatePreviewClient, form.previewClient);

  const formValues = form.watch();

  useAutoSaveAssumptions({
    formValues,
    selections: envSelections.selections,
    costs: envCosts.costs,
    clientHasStartedLtc: form.clientHasStartedLtc,
  });

  const handleResetCareTimeline = useCallback(() => {
    const durationPatches = form.getResetDurationPatches();
    const selectionPatches = envSelections.getResetSelectionPatches();
    const costPatches = envCosts.getResetCostPatches();

    form.updatePreviewClient({
      ...form.previewClient,
      ...durationPatches,
      ...selectionPatches,
      ...costPatches,
    });
  }, [form, envSelections, envCosts]);

  const isCareTimelineAllDefaults =
    form.isAllPredictedDurations() && envSelections.isAllDefaultSelections() && envCosts.isAllDefaultCosts();

  return (
    <div className="space-y-4 sm:space-y-6">
      <ProjectedCostBanner previewClient={form.previewClient} />

      {!form.clientHasStartedLtc && (
        <div className="rounded-xl border border-gray-300 bg-white p-4 sm:p-6">
          <CareAssumptionsSection
            control={form.control}
            watch={form.watch}
            previewClient={form.previewClient}
            updatePreviewClient={form.updatePreviewClient}
            predictedLtcAtAge={form.predictedLtcAtAge}
          />
        </div>
      )}

      <div className="rounded-xl border border-gray-300 bg-white p-4 sm:p-6">
        <CareTimelineTable
          watch={form.watch}
          setValue={form.setValue}
          previewClient={form.previewClient}
          updatePreviewClient={form.updatePreviewClient}
          isPastPhase={form.isPastPhase}
          selections={envSelections.selections}
          selectEnvironment={envSelections.selectEnvironment}
          costs={envCosts.costs}
          useLocalRate={envCosts.useLocalRate}
          localCosts={envCosts.localCosts}
          saveCost={envCosts.saveCost}
          onResetToPredicted={handleResetCareTimeline}
          isResetDisabled={isCareTimelineAllDefaults}
        />
      </div>

      <div className="rounded-xl border border-gray-300 bg-white p-4 sm:p-6">
        <InflationRateSection
          control={form.control}
          watch={form.watch}
          previewClient={form.previewClient}
          updatePreviewClient={form.updatePreviewClient}
        />
      </div>
    </div>
  );
}
